/*
 * Copyright (c) 2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: EditorView.tsx
 * Project: mle-client
 * Committed last: 2021/11/11 @ 1844
 * ---
 */

import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router';
import {Decoder} from '@revodigital/mpes/lib';
import {mleDomainGqlClient} from '../../../api/domain';
import {GET_LABEL_BY_ID} from '../../../api/domain/queries.gql';
import {EditorView} from '../../../pages/EditorView';
import {MLE_CANVAS_ID, redirect} from '../../../common/utils';
import {LabelPaths} from '../../../paths/label.paths';
import {Editor,} from '../../../store/observables/Editor';
import {MleToaster, Toasts} from '../../../common/toast';
import {PamelaEntitiesProvider} from '../../../common/pamela-utils';
import {EditorInstanceManager} from '../../../store/observables/EditorInstanceManager';
import {Label} from '../../../entities';
import {MyLabelAuthFeature} from '../../../store/features/mylabel/auth/MyLabelAuthFeature';

export const EditorProvider = () => {
  const {labelId} = useParams();
  let [editor, setEditor] = useState<Editor>();

  useEffect(() => {
    EditorInstanceManager.destroy();
    PamelaEntitiesProvider.destroyAll();
    (async () => {
      const labelRes = await mleDomainGqlClient.query({
        query: GET_LABEL_BY_ID,
        variables: {
          id: parseInt(labelId as string)
        },
        fetchPolicy: 'network-only'
      });

      if (!labelRes.data.label)
        return redirect(LabelPaths.NOT_FOUND);

      try {
        const decoder = new Decoder();
        const decodedData = await decoder.decodeBuffer(labelRes.data.label.bodyContent);

        const editor = EditorInstanceManager.getInstance({
          labelHeader: decodedData.header,
          canvasProps: decodedData.canvasprops,
          metadata: decodedData.metadata,
          containerId: MLE_CANVAS_ID,
          labelId: parseInt(labelId as string),
          persistedLayers: decodedData.content.data,
          dataRefs: decodedData.dataRefs || []
        });

        editor.initListeners();

        // Load connection detail
        const label = labelRes.data.label as Label;
        const cnt = await MyLabelAuthFeature.checkConnection(label.user?.company?.id as number);
        editor.mylabelAuthFeature.setIsConnected(cnt);

        setEditor(editor);
        MleToaster.getInstance().show(Toasts.INIT_CANVAS);
        MleToaster.getInstance().show(Toasts.MEASURE_UNIT(editor.projectData.projectOptions.measureUnit));
      } catch (e) {
        throw e;
      }
    })();

    window.onbeforeunload = () => {
      return 'Ricaricando la pagina alcune modifiche potrebbero andare perse. Salva il progetto.';
    };
  }, [labelId]);

  return <EditorView editor={ editor }/>;
};
